module.exports = require("stringz");